import { render, staticRenderFns } from "./MyBottomNavigation.vue?vue&type=template&id=f0aaa8ee&scoped=true"
import script from "./MyBottomNavigation.vue?vue&type=script&lang=js"
export * from "./MyBottomNavigation.vue?vue&type=script&lang=js"
import style0 from "./MyBottomNavigation.vue?vue&type=style&index=0&id=f0aaa8ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0aaa8ee",
  null
  
)

export default component.exports